module.exports = __webpack_public_path__ + "assets/img/14_926.12c9d8b4.jpg";